import styled, { css } from 'styled-components';

export const Wrapper = styled.div<{ $minHeight?: number; $maxHeight?: number }>`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${({ $minHeight }) =>
    $minHeight &&
    css`
      .ql-editor {
        min-height: ${$minHeight}px;
        overflow-y: auto;
      }
    `}

  ${({ $maxHeight }) =>
    $maxHeight &&
    css`
      .ql-editor {
        max-height: ${$maxHeight}px;
        overflow-y: auto;
      }
    `}
`;
